<script setup>
defineProps({ blok: Object })
</script>

<template>	

	<div v-editable="blok" class="w-full flex flex-row justify-start items-start ">
		<img v-if="blok.icon?.filename" class="w-20 md:w-36" :src="blok.icon.filename" :alt="blok.icon.alt" :title="blok.icon.title" />
		<div v-else class="w-20 md:w-36"></div> 
		<div class="pl-4 md:px-6 max-w-sm ">
			<h4 v-if="blok.title" class="text-md font-semibold">{{ blok.title }}</h4>
			<p v-if="blok.body" class="text-sm text-white/70">{{blok.body}}</p>
		</div>
	</div>
</template>
 
